import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { ChevronRight } from 'lucide-react';
import '../../components/subPages.css';
import { db } from '../firebase/firebase-config';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext';

const AnnouncementsPage = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [heroImage, setHeroImage] = useState('');
  /* Dil beynini buraya da bağladık kanka */
  const { lang } = useLanguage();

  useEffect(() => {
    const fetchData = async () => {
      // 1. Duyuruları Çek
      const annQ = query(collection(db, "announcements"), orderBy("createdAt", "desc"));
      const annSnap = await getDocs(annQ);
      setAnnouncements(annSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));

      // 2. Hero için Slider Görselini Çek
      const sliderQ = query(collection(db, "sliders"), orderBy("createdAt", "desc"), limit(1));
      const sliderSnapshot = await getDocs(sliderQ);
      if (!sliderSnapshot.empty) {
        setHeroImage(sliderSnapshot.docs[0].data().url);
      }
    };
    fetchData();
  }, []);

  // KANKA: Firestore'dan gelen veriyi dile göre seçen yardımcı fonksiyonlar
  const getAnnTitle = (ann) => {
    if (lang === 'AR') return ann.titleAr || ann.titleEn || ann.title;
    if (lang === 'EN') return ann.titleEn || ann.title;
    return ann.title;
  };

  const getAnnContent = (ann) => {
    const content = lang === 'AR' ? (ann.contentAr || ann.contentEn || ann.content) : 
                    lang === 'EN' ? (ann.contentEn || ann.content) : ann.content;
    return content.substring(0, 80) + "...";
  };

  return (
    <div className="subpage-wrapper">
      <Navbar/>
      
      {/* Dinamik Arka Planlı Hero */}
      <section 
        className="subpage-hero" 
        style={{ backgroundImage: `url(${heroImage || 'https://via.placeholder.com/1920x600'})` }}
      >
        <div className="hero-overlay">
          {/* Başlık ve açıklama dile göre değişiyor kanka */}
          <h1>
            {lang === 'TR' ? "Haberler ve " : lang === 'AR' ? "الأخبار و" : "News and "}
            <span>{lang === 'TR' ? "Duyurular" : lang === 'AR' ? "الإعلانات" : "Announcements"}</span>
          </h1>
          <p>
            {lang === 'TR' 
              ? "Sektördeki güncel gelişmeleri ve duyurularımızı buradan takip edebilirsiniz." 
              : lang === 'AR'
              ? "يمكنكم متابعة آخر التطورات في القطاع وإعلاناتنا من هنا."
              : "You can follow the latest developments in the sector and our announcements here."}
          </p>
        </div>
      </section>

      <div className="container page-content">
        <div className="announcement-display-grid">
          {announcements.map((ann) => (
            <div key={ann.id} className="modern-ann-card-premium compact">
              <div className="ann-img-wrapper">
                <img src={ann.imageUrl} alt={getAnnTitle(ann)} />
                <span className="ann-badge">{ann.date}</span>
              </div>
              <div className="ann-content-info">
                <h3>
                  {/* Dinamik başlık seçimi */}
                  {getAnnTitle(ann)}
                </h3>
                <p>
                  {/* Dinamik içerik özeti */}
                  {getAnnContent(ann)}
                </p>
                <button className="ann-detail-btn">
                  {lang === 'TR' ? "Detaylı İncele" : lang === 'AR' ? "عرض التفاصيل" : "Examine in Detail"} <ChevronRight size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default AnnouncementsPage;